import { Injectable } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { StorageService } from '../common/services/storage.service';
import { Observable, throwError, catchError } from 'rxjs';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class GuestAuthInterceptor implements HttpInterceptor {
  constructor(private storage: StorageService, private router: Router) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const pin = this.storage.get('pin');
    if (pin) {
      const authReq = req.clone({ setHeaders: { Authorization: `pin ${pin}` } });
      const redirectBackUrl = this.router.routerState.snapshot.url;
      return next.handle(authReq).pipe(
        catchError((error: HttpErrorResponse) => {
          if (error && (error.status === 401 || error.status === 403 || error.status === 404)) {
            this.storage.remove('pin');
            this.router.navigate(['/logout'], { queryParams: { next: redirectBackUrl } });
          }
          return throwError(() => error);
        })
      );
    }
    return next.handle(req);
  }
}
